import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { KeyValue, ObjektEinsicht, PayloadArchivDocumentList, PayloadBoolean, PayloadIEEingangList, PayloadObjektEinsichtStatus, PayloadSchaden, PayloadSchadenBuchungDetail, PayloadSchadenChecklistContainer, PayloadSchadenElektronischeKommunikationLogList, PayloadSchadenFeedbackList, PayloadSchadenResultList, PayloadSchadenzahlungDetail, PayloadTerminList } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestSchadenService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchSchaden(searchParams: KeyValue<string, any>[]): Observable<PayloadSchadenResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      { params });
    return this.http
      .get<PayloadSchadenResultList>(
        this.baseUrl + '/schaden/suche',
        options);
  }

  public getSchaden(schadenNr: number): Observable<PayloadSchaden> {
    return this.http
      .get<PayloadSchaden>(this.baseUrl + '/schaden/' + schadenNr, this.httpOptions);
  }

  public getDocuments(schadenNr: number): Observable<PayloadArchivDocumentList> {
    return this.http
      .get<PayloadArchivDocumentList>(this.baseUrl + '/schaden/' + schadenNr + '/documents', this.httpOptions);
  }

  public getTermine(schadenNr: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/schaden/' + schadenNr + '/termine', this.httpOptions);
  }

  public getSchadenZahlungDetail(schadenNr: number, zahlungId: number): Observable<PayloadSchadenzahlungDetail> {
    return this.http
      .get<PayloadSchadenzahlungDetail>(this.baseUrl + '/schaden/' + schadenNr + '/zahlung/' + zahlungId, this.httpOptions);
  }

  public getSchadenBuchungDetail(schadenNr: number, buchungId: number): Observable<PayloadSchadenBuchungDetail> {
    return this.http
      .get<PayloadSchadenBuchungDetail>(this.baseUrl + '/schaden/' + schadenNr + '/buchung/' + buchungId, this.httpOptions);
  }

  public getSchadenElektronischeKommunikationLog(schadenNr: number): Observable<PayloadSchadenElektronischeKommunikationLogList> {
    return this.http
      .get<PayloadSchadenElektronischeKommunikationLogList>(this.baseUrl + '/schaden/' + schadenNr + '/schelekkommlog', this.httpOptions);
  }

  public getEinsichtStatus(schadenId: number): Observable<PayloadObjektEinsichtStatus> {
    return this.http
      .get<PayloadObjektEinsichtStatus>(this.baseUrl + '/schaden/' + schadenId + '/einsicht', this.httpOptions);
  }

  public einsichtBeantragen(schadenId: number, body: ObjektEinsicht): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/schaden/' + schadenId + '/einsicht',
        body,
        this.httpOptions);
  }

  public getSchadenChecklist(schadenId: number): Observable<PayloadSchadenChecklistContainer> {
    return this.http
      .get<PayloadSchadenChecklistContainer>(this.baseUrl + '/schaden/' + schadenId + '/checklist', this.httpOptions);
  }

  public getSchadenFeedback(schadenId: number): Observable<PayloadSchadenFeedbackList> {
    return this.http
      .get<PayloadSchadenFeedbackList>(this.baseUrl + `/schaden/${schadenId}/feedback`, this.httpOptions);
  }

  public getSchadenZahlungEingang(schadenId: number): Observable<PayloadIEEingangList> {
    return this.http
      .get<PayloadIEEingangList>(this.baseUrl + `/schaden/${schadenId}/zahlung/eingang`, this.httpOptions);
  }
}
